import type { EducationSearchItem } from '~/Features/Search/Education/Service/EducationSearchItem.csharp';
import { EducationSearchItemType } from '~/Features/Search/Education/Service/EducationSearchItemType.csharp';
import { LinkCardVariant } from '~/Partials/LinkCard/LinkCardVariant.csharp';
import type { StudyCardProps } from '~/Partials/StudyCard/StudyCard';

export function mapToStudyCardProps(data: EducationSearchItem): StudyCardProps {
    return {
        linkUrl: data.linkUrl,
        studyName: data.name,
        studyLevelLabel: data.levelLabel,
        studyType:
            data.type === EducationSearchItemType.CampusStudy || data.type === EducationSearchItemType.CampusSubject
                ? 'campus'
                : 'online',
        studyLocations: data.locations,
        studyFormTypes: data.studyFormTypes,
        studyDuration: data.durationInYears,
        variant: LinkCardVariant.Red,
    };
}
